import { render, staticRenderFns } from "./QOption.vue?vue&type=template&id=39c36632&scoped=true"
import script from "./QOption.vue?vue&type=script&lang=js"
export * from "./QOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c36632",
  null
  
)

export default component.exports